import { useContext, useEffect, useState } from "react";
import { planEatApi } from "../../../planEatApi/PlanEatApi";
import { IPriceModelContent, IVersionedObject } from "../../../planEatApi/PlanEatFacade";
import { PriceModelCreationModal } from "../../../components/modals/PriceModelCreationModal";
import toast from "react-hot-toast";
import { MdClose, MdEdit } from "react-icons/md";
import { resetPriceModel } from "../../../utils/resetObjects";
import { IconButton, makeStyles } from "@material-ui/core";
import { AddItemButton } from "../../../components/ui/AddItemButton";
import { OfficeContext } from "../../../config/Context";
import { extractErrorMessage } from "../../../components/utils/ErrorHandler";

const useStyles = makeStyles((theme: any) => ({
    content: {
        width: '100%',
        background: '#FFFFFF',
        boxShadow: '0px 4px 4px rgba(11, 37, 89, 0.1)',
        borderRadius: 8,
        padding: 30
    },
    table: {
        maxHeight: 380,
        overflowY: "scroll"
    },
    tableHeaderRow: {
       display: 'grid',
       gridTemplateColumns: '25% 25% 50%',
       width: '100%',
       fontWeight: 'bold'
    },  
    tableDataRow: {
        display: 'grid',
        gridTemplateColumns: '25% 25% 50%',

        paddingTop: 10,
        paddingBottom: 10,

        width: '100%',
        borderBottom: '1px dotted grey',
        '& > * ': {
            display: 'flex',
            justifyContent: 'start',
            alignItems: 'center'
        }
    },
    indexContent : {
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',

        color: theme.palette.primary.main,
        border: "1px solid",
        borderColor: theme.palette.primary.main,
        borderRadius: '50%',

        height: 30,
        width: 30,
        padding: 10,
        marginRight: 5
    }  
}));

export const AdminPriceModel: React.FC = () => {
    // Styling
    const classes = useStyles()

    const officeContext = useContext(OfficeContext);  

    // State
    const [priceModelsView, setPriceModelsView] = useState<any[]>([]);
    const [priceModels, setPriceModels] = useState<IVersionedObject<IPriceModelContent>[]>([])
    const [priceModelCreationModalHidden, setPriceModelCreationModalHidden] = useState(true)

    const [priceModel,setPriceModel] = useState<IPriceModelContent>({
        id: "",
        description: "",
        name: "",
        officeId: "",
        priceModelParameters: "",
        priceModelType: ""
    })

    async function getDatabase(){
        if(officeContext){
            await planEatApi.getPriceModels()
            .then((response) => {
                const priceModelsSorted = response.data.sort((a,b) => a.content.name.localeCompare(b.content.name))
                setPriceModels(priceModelsSorted)
            }).catch((e) => {
                console.log(e)}
            )
        }
    }
    
    useEffect(() => {
        getDatabase()
    },[officeContext])

    useEffect(() => {
        displayPriceModels()
    },[priceModels])


    function displayPriceModels(){
        var tmpPriceModelView : any[] = []
        priceModels.forEach((priceModelItem,index) => {
            tmpPriceModelView.push(
                <div className={classes.tableDataRow}>
                    <div>
                        <div className={classes.indexContent}>{index+1}</div>
                        <div>{priceModelItem.content.name}</div>    
                    </div>
                    <div>{priceModelItem.content.description}</div>
                    <div style={{display:'flex',justifyContent:'space-between'}}>
                        <div>{priceModelItem.content.priceModelType}</div>
                        <div>
                            <IconButton onClick={() => {setPriceModel(priceModelItem.content);setPriceModelCreationModalHidden(false)}}> 
                                <MdEdit/>
                            </IconButton>
                            <IconButton onClick={() => {postDeletePriceModel(priceModelItem.content.id)}}> 
                                <MdClose/>
                            </IconButton>
                        </div>
                    </div>
                </div>
            )
        })
        setPriceModelsView(tmpPriceModelView)
    }

    useEffect(() => {
        if(priceModelCreationModalHidden){
            setPriceModel(resetPriceModel())
        }
    },[priceModelCreationModalHidden])

    function postPriceModel(priceModel: IPriceModelContent){
        if(officeContext?.office){
            priceModel.officeId = officeContext?.office.content.id
            planEatApi.postPriceModel(priceModel)
            .then(() => {
                toast.success("Price model was " + (priceModel.id ? "updated" : "created"))
                setPriceModelCreationModalHidden(true)
                setPriceModel(resetPriceModel())
                getDatabase()
            })
            .catch((e) => {
                extractErrorMessage(e, "Failed creating seating")
            })
        }
        
    }

    function postDeletePriceModel(priceModelId: string){
        planEatApi.postDeleteForPriceModel(priceModelId)
        .then(() => {
            toast.success("Price model was deleted")
            setPriceModel(resetPriceModel())
            getDatabase()
        })
        .catch((e) => {
            extractErrorMessage(e, "Failed deleting price model")
        })
    }

    return (
        <div className={classes.content}>
            <div>
                <div className={classes.tableHeaderRow} style={{fontWeight: 'bold'}}>
                    <div>
                        Name
                    </div>
                    <div>
                        Description
                    </div>
                    <div>
                        Auction type
                    </div>
                </div>
                <div className={classes.table}>
                    {priceModelsView}
                </div>
                <div>
                    <AddItemButton title="Add Price Model" onClick={() => {setPriceModelCreationModalHidden(false)}}></AddItemButton>
                </div>
            </div>
            <div>
                <PriceModelCreationModal 
                    postPriceModel={postPriceModel}
                    priceModel={priceModel}
                    setPriceModel={setPriceModel}
                    priceModelCreationModalHidden={priceModelCreationModalHidden} 
                    setPriceModelCreationModalHidden={setPriceModelCreationModalHidden}/>
            </div>
        </div>
    );
}